<template>
  <div :class="input.customized.connected ? 'connected' : 'disconnected'">
    <img
      class="tool"
      :src="require(`@/${input.root}/${input.toolbar.path}`)"
    />
    <v-icon
      style="vertical-align: middle"
      v-if="input.customized.connected"
      large
      >mdi-access-point
    </v-icon>
    <v-icon
      style="vertical-align: middle"
      v-else
      large
      >mdi-access-point-off
    </v-icon>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "KoioteSnap7Connection",
  props: {
    input: Object,
  },

  computed: {
    ...mapState("nodered", ["client", "showing_history_address"]),
  },

  methods: {
    ...mapActions("nodered", ["doSubscribe", "doUnsubscribe", "doPublish", "addHistoryValue"]),
  },

  created() {
    console.group("CREACION DE KOIOTE SNAP7")
    console.log(this.input.customized.topic_read)
    console.groupEnd()
    if(this.input.customized.topic_read!=''){

      this.doSubscribe(this.input.customized.topic_read);

      this.client.on("message", (topic, message) => {
        console.log(topic)
        if (topic === this.input.customized.topic_read) {

          const decoder = new TextDecoder("utf-8");
          const decodedMessage = JSON.parse(decoder.decode(message));
          const addresses = Object.keys(decodedMessage);
          // console.log(decodedMessage)
          addresses.forEach((data) => {
            
            const variableToChange = this.input.customized.vartable.find((v) => v.formatted_address == decodedMessage[data].memoria);
            // console.group("Variable a cambiar y mensaje recibido")
           
            // console.groupEnd();
            
            // if(variableToChange.formatted_address=="DB510DBD48"){
            //   console.log(decodedMessage[data])
            // }
            if (variableToChange) {
               
              variableToChange.value = (() => {
                switch (variableToChange.type) {
                  case "BIT":
                    return Boolean(decodedMessage[data].valor);
                  case "ENTERO":
                    return decodedMessage[data].valor;
                  case "REAL":
                    return decodedMessage[data].valor;
                  default:
                    return "";
                }
              })();
              if (variableToChange.formatted_address == this.showing_history_address)
                this.addHistoryValue(variableToChange);
            } else {
              return '?????'
            }
          });
        }
      });
    }

  },

  beforeDestroy() {
    this.doUnsubscribe(this.input.customized.topic_read);
  },
};
</script>

<style scoped>
.disconnected {
  height: 100%;
  text-align: center;
  border: dotted 2px black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.connected {
  height: 100%;
  text-align: center;
  border: dotted 2px black;
  background-color: #4caf5050;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.tool {
  height: 37px;
  width: 66px;
  resize: both;
}
</style>
